var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_1_",
    "data-name": "calendar (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15569",
    "data-name": "Path 15569",
    d: "M11.875,1.25H11.25V.625a.625.625,0,1,0-1.25,0V1.25H5V.625a.625.625,0,1,0-1.25,0V1.25H3.125A3.129,3.129,0,0,0,0,4.375v7.5A3.129,3.129,0,0,0,3.125,15h8.75A3.129,3.129,0,0,0,15,11.875v-7.5A3.129,3.129,0,0,0,11.875,1.25ZM1.25,4.375A1.875,1.875,0,0,1,3.125,2.5h8.75A1.875,1.875,0,0,1,13.75,4.375V5H1.25ZM11.875,13.75H3.125A1.875,1.875,0,0,1,1.25,11.875V6.25h12.5v5.625A1.875,1.875,0,0,1,11.875,13.75Z",
    fill: "#ff6036"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(6.562 8.437)",
    fill: "#ff6036"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(3.437 8.437)",
    fill: "#ff6036"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(9.687 8.437)",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar2);
export default __webpack_public_path__ + "static/media/calendar-2.a1c24a9a4c45bd97ba0ed7f16eceb30e.svg";
export { ForwardRef as ReactComponent };